import { ColorOptions, TextInputNewProps, TextNewProps } from '@jfs/ui-new'
import { DropdownProps } from '../../../../components/Dropdown'

export const styles = {
  textinputStyle: (editable: boolean) =>
    ({
      borderColor: editable ? ('#D1D3E2' as ColorOptions) : undefined,
      labelPaddingBottom: 8,
      borderRadius: 4,
      labelFontFamily: 'jiotype-medium',
      labelColor: '#757575' as ColorOptions,
      labelFontSize: 12,
      fontSize: 12,
      fontWeight: '500',
      selectionColor: 'BLUE',
      editable,
      paddingHorizontal: editable ? 8 : 0,
      color: 'BLACK_21',
      paddingVertical: 6,
      placeholderTextColor: '#757575' as ColorOptions,
      bgColor: editable ? 'WHITE' : 'TRANSPARENT',
      disabled: !editable,
      type: 'label',
    } as TextInputNewProps),
  dropDownStyle: (editable: boolean) =>
    ({
      fullWidthContent: true,
      minHeight: 31,
      transparentBorder: !editable,
      showIcon: editable,
      selectable: editable,
      textPaddingFromLeft: editable ? 14 : 0,
      labelType: 'label',
    } as DropdownProps),
  datePickerStyle: (editable: boolean) =>
    ({
      showYearDropdown: true,
      scrollableYearDropdown: true,
      dropdownMode: 'select',
      color: 'BLACK_21',
      labelPaddingBottom: 5,
      labelFontSize: 12,
      paddingVertical: 3,
      shouldCloseOnSelect: true,
      disabled: !editable,
      labelFontFamily: 'jiotype-medium',
      borderColor: editable ? ('#D1D3E2' as ColorOptions) : 'TRANSPARENT',
      bgColor: editable ? 'WHITE' : 'TRANSPARENT',
      paddingHorizontal: editable ? 16 : 0,
    } as any),
  titleText: {
    color: 'BLACK_21',
    fontFamily: 'jioType-medium',
    fontSize: 12,
  } as TextNewProps,
  detailsText: {
    color: 'BLACK_75',
    fontFamily: 'jioType-medium',
    fontSize: 12,
  } as TextNewProps,
}
